import type {RhythmTree} from './rhythm-tree';

/**
 * Generates a RhythmTree representing one complete bar.
 *
 * Implementations hold a live reference to their config and read structural
 * values (granularity, tupletBias, beatsPerBar) at generation time, so changes
 * take effect when the next bar is generated.
 *
 * The generator is responsible only for rhythm structure: it produces a pure
 * {@link RhythmTree} skeleton with no domain semantics. Rests and other domain
 * concerns are attached as separate decorations over the flattened event stream
 * at a later point.
 */
interface RhythmTreeGenerator {
  generate(): RhythmTree;
}

export {RhythmTreeGenerator};
